<template>
  <el-dialog
    :title="`匹配信息编辑（${editData.pkId}）`"
    :visible="visible"
    width="900px"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-form
      ref="editFrom"
      :inline="true"
      :model="form"
      label-width="200px"
      :rules="rules"
    >
      <div class="bg">
        <el-form-item label="匹配结果ID">
          <el-input v-model="form.pkId" disabled></el-input>
        </el-form-item>
        <el-form-item label="投诉歌单ID">
          <el-input v-model="form.tracklistId" disabled></el-input>
        </el-form-item>
        <el-form-item label="TME ID" prop="tmeId">
          <el-input v-model.number="form.tmeId"></el-input>
        </el-form-item>
        <el-form-item label="TME ID 类型">
          <el-select v-model="form.audioType">
            <el-option v-for="(name, id) in mediaTypeMap" :key="+id" :label="name" :value="+id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="确权状态">
          <el-select v-model="form.pkStatus" @change="handleStatusChange">
            <el-option v-for="(name, id) in matchStatusMap" :key="+id" :label="name" :value="+id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期限">
          <el-date-picker
            class="data-picker"
            v-model="form.expiresTime"
            type="datetime"
            placeholder="期限时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="匹配时平台ID">
          <el-input v-model.number="form.platId"></el-input>
        </el-form-item>
        <el-form-item label="匹配时平台状态">
          <el-select v-model="form.platStatus">
            <el-option
              v-for="(name, id) in platStatusMap"
              :key="+id"
              :label="name"
              :value="+id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="匹配时版权状态">
          <el-select v-model="form.cpStatus">
            <el-option
              v-for="(name, id) in cpStatusMap"
              :key="+id"
              :label="name"
              :value="+id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="匹配时版权公司(填ID)" prop="historyCompany">
          <el-input v-model.number="form.historyCompany"></el-input>
        </el-form-item>
        <el-form-item label="匹配时原始版权公司(填ID)" prop="historyOriginCompany">
          <el-input v-model.number="form.historyOriginCompany"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="经办人">
          <el-input v-model="form.operateUser"></el-input>
        </el-form-item>
        <el-form-item v-if="showUploadRight" label="权利文件">
          <verify-uploader
            action="/action/upload?type=license"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload"
            :file-list="form.rightFileList"
            :accept="'.' + rightFileExtType.join(',.')"
          >
            <el-button type="primary">上传文件</el-button>
            <p class="tip">支持格式：{{ rightFileExtType.join(',') }}</p>
          </verify-uploader>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" style="margin-top:30px">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script >
import { matchStatusMap, mediaTypeMap, platStatusMap, MATCH_STATUS, rightFileExtType } from '@/views/complaint/const.js'
import { MatchList } from '@/models/Complaint'
import { validateFileExt } from '@/utils/validate'
import { VerifyUploader } from '@/components'

const cpStatusMap = {
  1: '有版权',
  0: '无版权'
}

export default {
  name: 'MatchEditDialog',
  components: {
    VerifyUploader
  },
  props: {
    visible: Boolean,
    editData: {
      type: Object,
      require: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const rules = {
      tmeId: [{ required: true, message: 'TME ID 不能为空', trigger: 'blur' }],
      historyCompany: [{ required: true, message: '匹配时版权公司不能为空', trigger: 'blur' }],
      historyOriginCompany: [{ required: true, message: '匹配时原始版权公司不能为空', trigger: 'blur' }]
    }
    return {
      matchStatusMap,
      mediaTypeMap,
      cpStatusMap,
      platStatusMap,
      rightFileExtType,

      form: new MatchList(),
      rules
    }
  },
  computed: {
    showUploadRight() {
      return this.form.pkStatus === MATCH_STATUS.REPEAT_RIGHT.code || this.form.rightFileList.length > 0
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.form = new MatchList(this.editData)
      } else {
        this.$refs.editFrom.clearValidate()
      }
    }
  },
  methods: {
    handleStatusChange() {
      if (!this.showUploadRight) {
        this.form.rightFileList = []
      }
    },
    handlePreview(file) {
      open(file.url, '_blank')
    },
    handleBeforeUpload(file) {
      if (!validateFileExt(rightFileExtType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return false
      }

      const sameFile = this.form.rightFileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return false
      }

      return true
    },
    handleRemove(file, fileList) {
      this.form.rightFileList = fileList
    },
    handleError(err, file, fileList) {
      this.form.rightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleSuccess(resp, file, fileList) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5
      this.form.rightFileList = fileList.slice(-1)
    },
    handleClose() {
      if (this.loading) {
        this.$message.warning('数据提交中，请稍等！')
        return
      }
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      try {
        await this.$refs.editFrom.validate()
        this.$emit('submit', this.form.getBackendData())
      } catch {
        this.$message.warning('部分信息未填写')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.bg {
  background: #fafafb;
  border: 1px dashed #ccc;
  padding: 10px;

  ::v-deep {
    .el-form-item__content {
      width: 185px;
    }
    .el-date-editor {
      width: 185px;
    }

    .el-select {
      width: 185px;
    }
  }
}

::v-deep {
  .el-upload {
    text-align: left;

    .tip {
      margin-top: 5px;
      font-size: 12px;
      color: #999;
      line-height: 1.5;
    }
  }
}
</style>
